<script>
export default {
    name: 'SensorIcon',
};
</script>

<template>
    <svg width="24" height="24" class="fill-current" xmlns="http://www.w3.org/2000/svg"><g fill-rule="evenodd"><circle cx="12" cy="12" r="3"/><path d="M4.219 4.225L5.632 5.64A8.972 8.972 0 003 12a8.972 8.972 0 002.632 6.36L4.22 19.775A10.966 10.966 0 011 12c0-3.036 1.23-5.785 3.219-7.775zm15.557-.005A10.966 10.966 0 0123 12c0 3.038-1.232 5.79-3.224 7.78l-1.415-1.413A8.972 8.972 0 0021 12a8.972 8.972 0 00-2.639-6.367l1.415-1.413zM7.046 7.055L8.459 8.47A4.984 4.984 0 007 12c0 1.378.557 2.625 1.459 3.53l-1.413 1.415C5.782 15.679 5 13.931 5 12s.782-3.679 2.046-4.945zm9.9-.009A6.978 6.978 0 0119 12a6.978 6.978 0 01-2.054 4.954L15.53 15.54C16.438 14.635 17 13.383 17 12s-.562-2.635-1.47-3.54l1.416-1.414z"/></g></svg>
</template>
